<template>
  <article type="flex" class="item">
    <div class="item__header">
      <FileExcelOutlined class="item__icon" />
      <div class="item__title">{{ item.title }}</div>
    </div>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <p class="item__text">{{ item.description }}</p>

    <a :href="item.url" download>
      <a-button class="button">Descargar plantilla</a-button>
    </a>
  </article>
</template>

<script>
import { FileExcelOutlined } from "@ant-design/icons-vue";
import { defineComponent } from "vue";
export default defineComponent({
  components: {
    FileExcelOutlined,
  },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  computed: {
    // description() {
    //   const { url, description } = this.item;
    //   const text = description.split("XLSX");
    //   const aTag = `<a href="${url}" download target="_blank"> XLSX </a>`;
    //   return `${text[0]} ${aTag} ${text[1]}`;
    // },
  },
});
</script>

<style lang="sass" scoped>
.item
  border-top: $border-medium
  padding: 12px 24px
  color: $gray-8

  &__header
    display: flex
    align-items: center

  &__icon
    font-size: 24px

  &__title
    font-weight: 600
    padding-left: 8px

  &__text
    margin: 8px 0 0 32px

.button
  width: 90%
  margin: 12px auto 0
  display: block
</style>
